<div class="w-100 float-left">
    <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
        <h5 class="medium float-left"> {{'uploadBulk' | translate }} </h5>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-secondary" name="bulkUploadBack" (click)="goToBackPage()">
            <i class="fa fa-arrow-left mr-sm-2"></i> {{'back' | translate}}
        </button>
    </div>
</div>

<div class="w-100 float-left mb-4 b-b">
    <div class="form-group w-100 float-left align-v-center">
        <label class="medium col-2" for="exampleSelect1">{{'programName' |translate}} :</label>
        <span class=" ml-3">{{programName}}</span>
    </div>
    <div class="form-group w-100 float-left align-v-center">
        <label class="medium col-2" for="exampleSelect1">{{'chooseProcess' |translate}} :</label>
        <select class="form-control w-25 ml-3" id="exampleSelect1" [(ngModel)]="selectedProcess"
                (ngModelChange)="onProcessChange()"
                name="selectProcess">
            <option value="Select">{{'select' | translate}}</option>
            <option value="scoreUpload">{{'scoreUpload' | translate}}</option>
            <option value="kpiUpload">{{'kpiUpload' | translate}}</option>
            <option value="approversUpload">{{'approversUpload' | translate }}</option>
            <option value="bulkPublish">{{'bulkPublish' | translate}}</option>
            <option value="bulkRuleUpload">{{'bulkRuleUpload' | translate}}</option>
            <option value="bulkKpiDelete">{{'bulkKpiDelete' | translate}}</option>
        </select>
    </div>
    <ng-container *ngIf="selectedProcess != 'Select'">
        <div class="form-group w-100 float-left align-v-center">
            <label class="medium col-2" for="excelTypeSelect">{{'excelFileType' | translate}}:</label>
            <select class="form-control w-25 float-left ml-3" name="fileType" id="excelTypeSelect"
                    *ngIf="selectedProcess != 'Select'"
                    (change)="onFileTypeChange($event.target.value)">
                <option>{{'xlsx' | translate}}</option>
                <option>{{'xls' | translate}}</option>
            </select>
            <a href="javascript:void(0)" class="btn float-left ml-3" (click)="downloadTemplate(selectedProcess)">
                {{'download' | translate}} '{{selectedProcess | translate}}' {{'template' | translate }} </a>
        </div>
        <div class="form-group w-100 float-left align-v-center">
            <label class="medium col-2" for="excelTypeSelect">{{'selectFile' | translate}}:</label>
            <div class="relative">
                <input class="fileInput" type="file" name="browseFile" (change)="chooseFile($event)"
                       accept=".xlsx,.xls,.XLSX,.XLS"/>
                <button class="btn btn-primary ml-3" name="browseFileBtn"> {{'browse'|translate}}</button>
            </div>
            <label class="mb-0 ml-2" *ngIf="fileNameToUpload != null"> {{fileNameToUpload}}</label>
        </div>
        <ng-container *ngIf="fileNameToUpload != null">
            <div class="form-group w-100 float-left align-v-center">
                <label class="medium col-2" for="exampleSelect1">{{'comments' |translate}} :</label>
                <textarea placeholder="{{'enterComments' | translate}}" rows="2" name="bulkUploadComments"
                          class="form-control w-25 ml-3"
                          [(ngModel)]="comments"></textarea>
            </div>
            <div class="form-group w-100 float-left align-v-center">
                <label class="medium col-2"></label>
                <button class="btn btn-primary ml-3" (click)="uploadFile(selectedProcess)" name="uploadFiles"
                        [disabled]="uploadButtonDisable">{{'upload' | translate}}
                </button>
            </div>
        </ng-container>
    </ng-container>
</div>
<div class="w-100 float-left mb-4">
    <div class="w-100 float-left align-v-center mb-3">
        <h6 class="medium m-0">{{'processGrid' | translate}} </h6>
        <div style="flex-grow: 1;"></div>
        <button class="btn btn-primary float-right" (click)="getAll()" name="refreshGrid">
            <i class="fa fa-refresh mr-2 text-white"></i> {{'refreshGrid' | translate}}
        </button>
    </div>
    <div class="col-lg-12 col-md-12 float-left">
        <div class="light-bg w-100 float-left p-2 grid-details">
            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium">{{'uploadProcess' | translate}}</h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium">{{'title' | translate}}</h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium">{{'programName' | translate}}</h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium">{{'startDate' | translate}}</h6>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium">{{'status' | translate}}</h6>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium">{{'failureReason' | translate}}</h6>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left">
                <h6 class="mb-0 medium"> {{'attachFiles' | translate}} </h6>
            </div>
        </div>
        <ng-container>
            <div class="w-100 float-left p-2 grid-details" *ngFor="let data of allData">
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-0 text-truncate" ngbTooltip='{{data.uploadProcessType | translate}}'>
                        {{data.uploadProcessType | translate}}</h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-0">{{data.comment}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left" *ngIf="data.referenceName!=null">
                    <h6 class="mb-0 text-truncate" *ngIf="data.referenceName.length < 15"
                        ngbTooltip="{{data.referenceName}}">{{data.referenceName}}</h6>
                    <h6 class="mb-0 text-truncate" *ngIf="data.referenceName.length >= 15"
                        ngbTooltip="{{data.referenceName}}">{{data.referenceName}}</h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-0">{{getDateFormat(data.startDate)}}</h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-0">{{data.state | translate}}</h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-1 col-xs-1 float-left">
                    <h6 class="mb-0">{{data.failureReason}}</h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-1 col-xs-1 float-left">
                    <a href="#/menu/bulkupload" class="mb-0 small" *ngIf="data.attachedFiles.length > 0"
                       ngbTooltip="{{'clickToDownload' | translate}}"
                       (click)="downloadValidationFile(data.attachedFiles[0].filePath)">{{data.attachedFiles[0].fileType
                        | translate}}.{{getExtension(data.attachedFiles[0].name)}} </a>
                    <br/>
                    <a href="#/menu/bulkupload" class="mb-0 small" *ngIf="data.attachedFiles.length > 1"
                       ngbTooltip="{{'clickToDownload' | translate}}"
                       (click)="downloadValidationFile(data.attachedFiles[1].filePath)">{{data.attachedFiles[1].fileType
                        | translate}}.{{getExtension(data.attachedFiles[1].name)}} </a>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- PAGINATION -->

    <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
        <h6 class="float-left mb-0"> {{((page-1)*pageSize)+1}} - {{pageSize*(page-1)+allPageData.numberOfElements}}
            {{'itemsOf' | translate}} {{allPageData.totalElements}} </h6>
        <div class="float-left ml-2 align-v-center">
            <label class="m-0 float-left">{{'showItemsPerPage' | translate}}</label>
            <select class="form-control float-left w-auto ml-2 mb-0" name="UploadedItemsPerPage" [(ngModel)]="pageSize"
                    (change)="OnPageSizeChanged($event.target.value)">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
            </select>
        </div>
        <div style="flex-grow: 1;"></div>
        <ngb-pagination [collectionSize]="collectionSize" [rotate]="true" [pageSize]="pageSize" [maxSize]="5"
                        [ellipses]="false" [(page)]="page" [boundaryLinks]="true" (pageChange)="onPageChange($event)"
                        class="float-right"></ngb-pagination>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/bulkUpload/bulkUpload.html